import React, { useContext, useState, useEffect } from 'react'

import { useHistory } from 'react-router-dom'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { Button } from '@mui/material'
import { useFormik } from 'formik'
import AlertContext from '@/product/context/alert/alertContext'
import ProductContext from '@/product/context/product/productContext'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import CustomDialog from '@/product/components/organisms/Dialog'
import CommentContext from '@/product/context/comment/commentContext'
import * as Yup from 'yup'
import { handleRedirectInternal, mapData } from '@/product/common/components'
import { safeOpenInNewTab } from '@/product/common/urlValidation'
import ReplyComments from './ReplyComments'
import AuthContext from '@/product/context/auth/authContext'
import Layout from '@/product/components/templates/Layout'
import DynamicListing from '../Listing/dynamicListing'
import './Comments.css'
import ManageComments from './manageComments'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CommonContext from '@/product/context/common/commonContext'

const QuestionAnswer = (props) => {
    const dashboardContext = useContext(CommonContext)
    const { getMainDashboardData } = dashboardContext
    const alertContext = useContext(AlertContext)
    const [isLoading, setIsLoading] = useState(true)

    const { user } = useContext(AuthContext)

    const {
        all_comments,
        getAllComments,
        saveComment,
        responseStatus: replyCommentsResponse,
        clearResponse: clearComment,
    } = useContext(CommentContext)

    const { alldata_all_dropdown } = useContext(CustomCommonContext)

    const [disable, setDisable] = useState(false)

    const history = useHistory()
    const { setAlert } = alertContext

    const data = props.data
    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
        secondaryId: 0,
        projectType: 0,
    })
    const toggleFullScreenPopup = (
        popup,
        status,
        id,
        secondaryID,
        projectType
    ) => {
        if (popup) {
            setManage({ popup, status, id, secondaryID, projectType })
        } else {
            setManage({ popup, status: 'new', id: 0, secondaryID: 0 })
        }
    }

    const [commentsManage, setCommentsManage] = useState({
        popup: false,
        status: 'new',
        secondaryId: 0,
        id: 0,
    })
    const toggleFullScreenCommentsPopup = (popup, status, id, secondaryId) => {
        if (popup) {
            setCommentsManage({ popup, status, id, secondaryId: secondaryId })
        } else {
            if (props && props?.match?.params?.id) {
                handleRedirectInternal(history, 'questions_answers')
            }
            setCommentsManage({ popup, status: 'new', id: 0, secondaryId: 0 })
        }
    }

    const [manageAuction, setManageAuction] = useState({
        popup: false,
        status: 'new',
        id: 0,
        projectType: 0,
    })

    const toggleFullScreenPopupAuction = (popup, status, id, projectType) => {
        if (popup) {
            setManageAuction({ popup, status, id, projectType })
        } else {
            setManageAuction({ popup, status: 'new', id: 0 })
        }
    }

    const [tableBody, setTableBody] = useState([])
    const [tableAllBody, setTableAllBody] = useState({
        records: [],
        totalRecords: 0,
        setDisp: '',
    })
    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: global?.zb_custom_table_limit || 20,
            order: '',
            orderby: '',
            answered: '0',
            filters: {
                lot_no: {
                    type: 'in',
                    value: '',
                    field: 'p.id',
                },
                comment_id: {
                    type: 'in',
                    value: '',
                    field: 'p.id',
                },
            },
            project_id: 0,
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getAllComments(values, 'outsidePage')
        },
    })

    useEffect(() => {
        if (all_comments.from === 'outsidePage') {
            if (all_comments) {
                all_comments.records.map((data) => {
                    if (data.category !== '') {
                        let idValue = alldata_all_dropdown.filter(
                            (item) =>
                                item.id == data.category &&
                                item.variable == 'category'
                        )
                        if (idValue.length) {
                            let values = idValue[0]
                            data.category = values.description
                        }
                    }
                })
                setTableBody(
                    all_comments.records.length ? all_comments.records : []
                )
            }
            setTableAllBody(all_comments)
            setIsLoading(false)
        }
    }, [all_comments])

    const resetFrom = () => {
        formik.setValues({
            searchterm: '',
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            project_id: 0,
        })
        formik.handleReset()
        setIsLoading(false)
    }

    const onClickAuction = (id, secondaryID) => {
        // toggleFullScreenPopupAuction(true, 'edit', id, 12)
        // console.log(id, secondaryID, 'sttyyy')
        // window.open(
        //     `${process.env.REACT_APP_FRONTEND_URL}productView/${secondaryID}`,
        //     '_blank',
        //     'noopener,noreferrer'
        // )
        handleRedirectInternal(history, `listing/edit/${secondaryID}`)
    }
    const onClickProductView = (id, secondaryID) => {
        safeOpenInNewTab(
            `${process.env.REACT_APP_FRONTEND_URL}productView/${secondaryID}`
        )
    }

    const onClickComment = (id, secondaryID) => {
        handleRedirectInternal(
            history,
            `questions_answers/${id}/${secondaryID}`
        )
        // toggleFullScreenCommentsPopup(true, 'edit', id, secondaryID)
    }

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.page = 1
        formik.values.filters.lot_no.value = props.match.params.productId || 0
        formik.values.answered = '0'
        getAllComments(formik.values, 'outsidePage')
        getMainDashboardData(
            global.customDashboardFilter ? global.customDashboardFilter : {}
        )
    }, [])

    useEffect(() => {
        if (props?.match?.params?.id && props.match.params.productId) {
            onClickComment(props.match.params.id, props.match.params.productId)
        }
    }, [props])

    const onClickEdit = (id, secondaryID, type) => {
        if (type === 'answer') {
            toggleFullScreenPopup(true, type, id, secondaryID)
        } else if (type === 'new_answer') {
            formikAddComment.values.comment_id = id
            formikAddComment.values.project_id = secondaryID
            setAddCommentPopup(true)
        }
    }

    const onClickViewUser = (id, type) => {
        handleRedirectInternal(history, `users/view/${id}`)
    }

    const tableValues = [
        {
            field: 'projects_avatar',
            type: 'imagewithurl',
            folder: 'product',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Picture',
            custom: true,
        },
        {
            field: 'project_id',
            type: 'hyperlink',
            clickID: 'id',
            firstChild: false,
            sort: true,
            sortField: 'c.project_id',
            disablePadding: false,
            onclick: onClickProductView,
            secondaryClickID: 'project_id',
            label: 'Lot #',
            filterable: true,
            filterField: 'c.project_id',
        },
        {
            field: 'user_id',
            type: 'hyperlink',
            clickID: 'user_id',
            onclick: onClickViewUser,
            firstChild: false,
            disablePadding: false,
            label: 'User ID',
            sort: true,
            sortField: 'c.user_id',
            filterable: true,
            filterField: 'c.user_id',
        },
        {
            field: 'users_first_name,users_last_name',
            type: '',
            firstChild: false,
            disablePadding: false,
            label: 'Name',
            sort: true,
            sortField: 'u.first_name',
            filterable: true,
            filterField: 'u.first_name,u.last_name',
        },

        {
            field: 'projects_title',
            type: 'hyperlink',
            clickID: 'id',
            onclick: onClickAuction,
            secondaryClickID: 'project_id',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Lot Title',
            filterable: true,
            filterField: 'p.title',
        },

        {
            field: 'comment',
            type: 'hyperlink',
            firstChild: false,
            click: true,
            onclick: onClickComment,
            clickID: 'id',
            secondaryClickID: 'project_id',
            disablePadding: false,
            label: 'Question',
            sort: true,
            sortField: 'c.comment',
            filterable: true,
            filterField: 'c.comment',
        },
        {
            field: 'last_reply',
            type: 'customLabelColor',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Answer',
            labelColorFieldCheck: 'last_reply_published',
            successColor: 'green',
            failColor: 'red',
        },
        {
            field: 'created_at',
            type: 'datetime',
            sort: true,
            sortField: 'c.created_at',
            filterField: 'c.created_at',
            firstChild: false,
            disablePadding: false,
            label: 'Date',
        },
        {
            field: 'custom_projects_year',
            type: '',
            firstChild: false,
            disablePadding: false,
            label: 'Year',
            sort: true,
            sortField: 'it.year',
            filterable: true,
            filterField: 'it.year',
        },
        {
            field: 'custom_projects_manufacturer',
            type: '',
            firstChild: false,
            disablePadding: false,
            label: 'Make',
            sort: true,
            sortField: 'it.manufacturer',
            filterable: true,
            filterField: 'it.manufacturer',
        },
        {
            field: 'custom_projects_model_no',
            type: '',
            firstChild: false,
            disablePadding: false,
            label: 'Model',
            sort: true,
            sortField: 'it.model_no',
            filterable: true,
            filterField: 'it.model_no',
        },
        {
            field: 'custom_projects_serial_no',
            type: '',
            firstChild: false,
            disablePadding: false,
            label: 'Vin',
            sort: true,
            sortField: 'it.serial_no',
            filterable: true,
            filterField: 'it.serial_no',
        },
        {
            field: 'custom_projects_unit_no',
            type: '',
            firstChild: false,
            disablePadding: false,
            label: 'Unit No',
            sort: true,
            sortField: 'it.unit_no',
            filterable: true,
            filterField: 'it.unit_no',
        },
        {
            field: 'custom_projects_mileage',
            type: '',
            firstChild: false,
            disablePadding: false,
            label: 'Mileage',
            sort: true,
            sortField: 'it.mileage',
            filterable: true,
            filterField: 'it.mileage',
        },
        {
            field: 'custom_projects_asset_no',
            type: '',
            firstChild: false,
            disablePadding: false,
            label: 'Asset #',
            sort: true,
            sortField: 'it.asset_no',
            filterable: true,
            filterField: 'it.asset_no',
        },
        {
            field: 'custom_projects_category',
            type: 'singleSelect',
            firstChild: false,
            sort: true,
            sortField: 'it.category',
            disablePadding: false,
            valueOptions: alldata_all_dropdown
                .filter(
                    (value) =>
                        value.variable === 'category' && value.level === 0
                )
                .map((item) => {
                    let valueChanged = {}
                    valueChanged.label = item.description
                    valueChanged.value = item.id
                    return valueChanged
                }),
            label: 'Category',
            filterable: true,
            filterField: 'it.category',
        },

        // {
        //     field: 'email',
        //     type: '',
        //     firstChild: true,
        //     sort: false,
        //     disablePadding: false,
        //     label: 'Email',
        // },
    ]

    const getMultipleAction = () => {
        let actionPush = []

        actionPush.push({
            buttonType: 'open_in_new',
            clickType: 'answer',
            clickID: 'id',
            secondaryClickID: 'project_id',
            onclick: onClickAuction,
            tooltipTitle: 'Visit Auction',
        })
        actionPush.push({
            buttonType: 'visibility',
            clickType: 'answer',
            clickID: 'id',
            secondaryClickID: 'project_id',
            onclick: onClickComment,
            tooltipTitle: 'View Comment Details',
        })
        // actionPush.push({
        //     buttonType: 'add',
        //     clickType: 'new_answer',
        //     clickID: 'id',
        //     secondaryClickID: 'project_id',
        //     onclick: onClickEdit,
        //     tooltipTitle: 'Add an Answer',
        // })

        return actionPush
    }

    tableValues.push({
        field: 'action',
        type: 'button',
        clickID: 'id',
        secondaryClickID: 'project_id',
        sort: false,
        firstChild: false,
        disablePadding: false,
        label: 'Action',
        isMultiple: getMultipleAction(),
    })

    const [addCommentPopup, setAddCommentPopup] = useState(false)
    const changeAddCommentPopup = () => {
        setAddCommentPopup(!addCommentPopup)
    }

    const validationAddComment = Yup.object({
        comment: Yup.string().required('Required'),
    })
    const formikAddComment = useFormik({
        initialValues: {
            table: '',
            comment: '',
            comment_id: 0,
            user_id: 0,
            project_id: 0,
        },
        validationSchema: validationAddComment,
        onSubmit: (values) => {
            formikAddComment.setSubmitting(true)
            if (values.comment !== '') {
                formikAddComment.values.table = 'comments'
                formikAddComment.values.user_id = user?.admin_id || 0
                saveComment(values)
                setDisable(true)
            }
        },
    })

    useEffect(() => {
        if (
            replyCommentsResponse?.from === 'saveComment' &&
            replyCommentsResponse?.status === 'success'
        ) {
            // setAlert('Commented Successfully', replyCommentsResponse.status)
            clearComment()
            formikAddComment.values.comment = ''
            setAddCommentPopup(false)
            setIsLoading(true)
            setDisable(false)
            formik.values.page = 1
            formik.values.filters.lot_no.value =
                props.match.params.productId || 0
            getAllComments(formik.values, 'outsidePage')
        }
    }, [replyCommentsResponse])

    const addCommentoption = [
        {
            label: 'Answer',
            placeholder: 'Add a Answer',
            type: 'textarea',
            class: 'col-12',
            name: 'comment',
            formik: formikAddComment,
        },
    ]

    const searchInfo = {
        formik: formik,
        data: [
            {
                label: 'Lot Id',
                placeholder: 'Enter Lot Number',
                class: `col-sm-4 col-12`,
                type: 'text',
                name: 'lot_no',
                filter: true,
            },
            {
                label: 'Questions',
                placeholder: 'Select Status',
                class: `col-sm-4 col-12`,
                type: 'select',
                name: 'answered',
                options: [
                    { value: '1', show: 'Answered' },
                    { value: '0', show: 'Not Answered' },
                    { value: '2', show: 'Not Answered Lot Closed' },
                    { value: '3', show: 'Unpublished Answers' },
                ],
                native: true,
            },
        ],
    }

    const closeFunction = () => {
        setAddCommentPopup(false)
        formikAddComment.values.comment = ''
    }

    return (
        <>
            <Layout>
                <div className="dashboard commentManagement">
                    <CustomSearch searchInfo={searchInfo} formik={formik} />
                    <CustomTable
                        formik={formik.values}
                        tableBody={tableBody}
                        tableValues={tableValues}
                        tableActions={[]}
                        allData={tableAllBody}
                        isLoading={isLoading}
                        loadingTemplate={'table'}
                        changeTableFunction={getAllComments}
                        fromVariable="outsidePage"
                        hideCompactView={true}
                        columnStorageVariable={'table_view_comments'}
                        columnVisibilityModel={{
                            custom_projects_year: false,
                            custom_projects_manufacturer: false,
                            custom_projects_model_no: false,
                            custom_projects_serial_no: false,
                            custom_projects_unit_no: false,
                            custom_projects_mileage: false,
                            custom_projects_asset_no: false,
                            custom_projects_category: false,
                        }}
                    />
                </div>
                <CustomDialog
                    title={'Answer'}
                    open={addCommentPopup}
                    function={changeAddCommentPopup}
                    disableBackdropClick
                    className="commentsModal"
                >
                    <p>{'Write an answer for this question'}</p>

                    <div className="row">
                        {Object.values(mapData(addCommentoption))}
                    </div>

                    <div className="actionWrapper">
                        <Button
                            id="comment_cancel"
                            onClick={() => closeFunction()}
                        >
                            {'Cancel'}
                        </Button>
                        <PrimaryButton
                            id="comment_submit"
                            onClick={formikAddComment.handleSubmit}
                            type="button"
                            label={'Submit'}
                            disabled={disable}
                        />
                    </div>
                </CustomDialog>
                <ReplyComments data={manage} function={toggleFullScreenPopup} />
                {/* <DynamicListing
                    data={manageAuction}
                    function={toggleFullScreenPopupAuction}
                    editModaltitle={'View Listing'}
                    noSubmitBtn={true}
                    noUpdateBtn={true}
                /> */}
            </Layout>
        </>
    )
}

export default QuestionAnswer
